import { render, staticRenderFns } from "./workbenchTab.vue?vue&type=template&id=c9415fcc"
import script from "./workbenchTab.vue?vue&type=script&lang=js"
export * from "./workbenchTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports